export default __webpack_public_path__ + "c4319df44aaf3ca9a2d15dea2ace5459.png";